import { getService } from '../../utils';

export const getRoutinesService = getService('routines');
